/* Progressive enhancement: scroll-reveal. No-JS = everything visible. Runs once per page. */
(function(){
  if(window.__tamHairInit) return; window.__tamHairInit = true;
  document.documentElement.classList.add('tam-js');
  var run = function(){
    var els = document.querySelectorAll('.tam-reveal:not(.in)');
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('in');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    },{threshold:.12, rootMargin:"0px 0px -40px 0px"});
    els.forEach(function(el){ io.observe(el); });
  };
  if(document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();
